import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21ad6ef7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"margin-top":"1vh"} }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row justify-start" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 app__label--medium desktop-only" }, "Id extern", -1))
const _hoisted_5 = { class: "col-9 app__property--medium" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Cod articol nav ")
const _hoisted_7 = { class: "row justify-start" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 app__label--medium desktop-only" }, "Denumire", -1))
const _hoisted_9 = { class: "col-9 app__property--medium" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Denumire ")
const _hoisted_11 = { class: "row justify-start" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 app__label--medium desktop-only" }, "Categorie", -1))
const _hoisted_13 = { class: "col-9 app__property--medium" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Categorie ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" No results ")
const _hoisted_16 = { class: "row justify-start" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-12 app__label--medium mobile-only",
  style: {"padding-top":"1rem"}
}, "Unitati de masura", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 app__label--medium desktop-only" }, "Unitati de masura", -1))
const _hoisted_19 = { class: "col-9" }
const _hoisted_20 = { class: "row justify-start" }
const _hoisted_21 = { class: "row justify-start" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-12 app__label--medium mobile-only",
  style: {"padding-top":"1rem"}
}, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 app__label--medium desktop-only" }, "Configuratie", -1))
const _hoisted_24 = { class: "col-9" }
const _hoisted_25 = { class: "row justify-start" }
const _hoisted_26 = { class: "col-auto" }
const _hoisted_27 = { class: "col-auto" }
const _hoisted_28 = { class: "col-auto" }
const _hoisted_29 = { class: "col-auto" }
const _hoisted_30 = { class: "col-auto" }
const _hoisted_31 = { class: "row justify-start" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 app__label--medium desktop-only" }, "Aliaj", -1))
const _hoisted_33 = { class: "col-9 app__property--medium" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Aliaj ")
const _hoisted_35 = { class: "row justify-start" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 app__label--medium desktop-only" }, "Tip", -1))
const _hoisted_37 = { class: "col-9 app__property--medium" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Tip ")
const _hoisted_39 = { class: "row justify-start" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 app__label--medium" }, "Vizibil la Client", -1))
const _hoisted_41 = { class: "col-9 app__property--medium" }
const _hoisted_42 = { style: {"display":"flex","justify-content":"flex-end"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_form, {
        onSubmit: _ctx.onSubmit,
        onReset: _ctx.onReset,
        class: "form__edit__article"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_q_input, {
                outlined: "",
                dense: "",
                modelValue: _ctx.article.code,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.article.code) = $event)),
                class: "form__input",
                label: "",
                onKeydown: _withKeys(_withModifiers(_ctx.focusOnArticleName, ["prevent"]), ["enter"]),
                "lazy-rules": "",
                rules: [ val => val && val.length > 0 || 'Please type something']
              }, _createSlots({ _: 2 }, [
                (_ctx.$q.platform.is.mobile)
                  ? {
                      name: "label",
                      fn: _withCtx(() => [
                        _hoisted_6
                      ])
                    }
                  : undefined
              ]), 1032, ["modelValue", "onKeydown", "rules"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_q_input, {
                outlined: "",
                dense: "",
                modelValue: _ctx.article.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.article.name) = $event)),
                class: "form__input",
                ref: "refArticleName",
                label: "",
                onKeydown: _withKeys(_withModifiers(_ctx.focusOnCategorySelection, ["prevent"]), ["enter"]),
                "lazy-rules": "",
                rules: [ val => val && val.length > 0 || 'Please type something']
              }, _createSlots({ _: 2 }, [
                (_ctx.$q.platform.is.mobile)
                  ? {
                      name: "label",
                      fn: _withCtx(() => [
                        _hoisted_10
                      ])
                    }
                  : undefined
              ]), 1032, ["modelValue", "onKeydown", "rules"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_q_select, {
                outlined: "",
                dense: "",
                ref: "refArticleCategorySelection",
                modelValue: _ctx.article.categoryPid,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => ((_ctx.article.categoryPid) = $event)),
                  _ctx.getCategoryDetailsAndSetSizes
                ],
                "fill-input": true,
                "emit-value": true,
                "map-options": true,
                "option-value": "pid",
                "option-label": "lantHierarchyCategories",
                label: "",
                options: _ctx.filteredOptionsCategories,
                onFilter: _ctx.filterFnCategories,
                style: {"max-width":"80vw"}
              }, _createSlots({
                "no-option": _withCtx(() => [
                  _createVNode(_component_q_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { class: "text-grey" }, {
                        default: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, [
                (_ctx.$q.platform.is.mobile)
                  ? {
                      name: "label",
                      fn: _withCtx(() => [
                        _hoisted_14
                      ])
                    }
                  : undefined
              ]), 1032, ["modelValue", "onUpdate:modelValue", "options", "onFilter"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_q_select, {
                  outlined: "",
                  modelValue: _ctx.article.um1,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.article.um1) = $event)),
                  options: _ctx.optionsUM,
                  label: "UM1",
                  style: {"width":"100px"}
                }, null, 8, ["modelValue", "options"]),
                _createVNode(_component_q_select, {
                  outlined: "",
                  class: "q-mx-sm",
                  modelValue: _ctx.article.um2,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.article.um2) = $event)),
                  options: _ctx.optionsUM,
                  label: "UM2",
                  style: {"width":"100px"}
                }, null, 8, ["modelValue", "options"]),
                _createVNode(_component_q_input, {
                  outlined: "",
                  disable: !_ctx.article.um2,
                  ref: "refThickness",
                  modelValue: _ctx.article.um1ToUm2,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.article.um1ToUm2) = $event)),
                  label: "indice transformare",
                  class: "form__input--sizes"
                }, null, 8, ["disable", "modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_q_input, {
                    outlined: "",
                    dense: "",
                    ref: "refLength",
                    disable: !_ctx.article.withLength,
                    modelValue: _ctx.article.sizeLength,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.article.sizeLength) = $event)),
                    label: "Lungime (mm)",
                    class: "form__input--sizes"
                  }, null, 8, ["disable", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_q_input, {
                    outlined: "",
                    dense: "",
                    disable: !_ctx.article.withWidth,
                    ref: "refWidth",
                    modelValue: _ctx.article.sizeWidth,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.article.sizeWidth) = $event)),
                    label: "Latime (mm)",
                    class: "form__input--sizes"
                  }, null, 8, ["disable", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_q_input, {
                    outlined: "",
                    dense: "",
                    disable: !_ctx.article.withThickness,
                    ref: "refThickness",
                    modelValue: _ctx.article.sizeThickness,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.article.sizeThickness) = $event)),
                    label: "Grosime (mm)",
                    class: "form__input--sizes"
                  }, null, 8, ["disable", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_q_input, {
                    outlined: "",
                    dense: "",
                    disable: !_ctx.article.withDiameter,
                    ref: "refDiameter",
                    modelValue: _ctx.article.sizeDiameter,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.article.sizeDiameter) = $event)),
                    label: "Diametru (mm)",
                    class: "form__input--sizes"
                  }, null, 8, ["disable", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_q_input, {
                    outlined: "",
                    dense: "",
                    disable: !_ctx.article.withHeight,
                    ref: "refHeight",
                    modelValue: _ctx.article.sizeHeight,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.article.sizeHeight) = $event)),
                    label: "Inaltime (mm)",
                    class: "form__input--sizes"
                  }, null, 8, ["disable", "modelValue"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_q_input, {
                outlined: "",
                dense: "",
                modelValue: _ctx.article.sizeAlloy,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.article.sizeAlloy) = $event)),
                class: "form__input",
                ref: "refArticleAliaj",
                label: "",
                disable: !_ctx.article.withAlloy,
                onKeydown: _withKeys(_withModifiers(_ctx.focusOnArticleType, ["prevent"]), ["enter"]),
                "lazy-rules": "",
                rules: [ val => val && val.length && _ctx.article.withAlloy> 0 || 'Completati Aliajul']
              }, _createSlots({ _: 2 }, [
                (_ctx.$q.platform.is.mobile)
                  ? {
                      name: "label",
                      fn: _withCtx(() => [
                        _hoisted_34
                      ])
                    }
                  : undefined
              ]), 1032, ["modelValue", "disable", "onKeydown", "rules"])
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              _createVNode(_component_q_input, {
                outlined: "",
                dense: "",
                modelValue: _ctx.article.sizeType,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.article.sizeType) = $event)),
                class: "form__input",
                ref: "refArticleType",
                label: "",
                disable: !_ctx.article.withType,
                "lazy-rules": "",
                rules: [ val => val && val.length > 0 && _ctx.article.withType|| 'Completati tipul']
              }, _createSlots({ _: 2 }, [
                (_ctx.$q.platform.is.mobile)
                  ? {
                      name: "label",
                      fn: _withCtx(() => [
                        _hoisted_38
                      ])
                    }
                  : undefined
              ]), 1032, ["modelValue", "disable", "rules"])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _createElementVNode("div", _hoisted_41, [
              _createVNode(_component_q_toggle, {
                modelValue: _ctx.article.isActive,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.article.isActive) = $event)),
                "true-value": true,
                "false-value": false
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createVNode(_component_q_btn, {
              label: "Reset",
              type: "reset",
              color: "primary",
              flat: "",
              disable: "",
              class: "q-ml-sm",
              "no-caps": ""
            }),
            _createVNode(_component_q_btn, {
              label: "Salveaza",
              type: "submit",
              color: "primary",
              "no-caps": "",
              "text-color": "white"
            })
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "onReset"])
    ])
  ]))
}